// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"93a2d2bb98d55e41ebb2","453":"9f46d03b053578df5b47"}[chunkId] + ".js";
};